export default {
  advancedPlanSettings: 'Configuración Avanzada del Plan',
  minimumWeeklySpend: 'Gasto Semanal Mínimo',
  minSpendInfo: 'Límites mínimos de inversión publicitaria para una semana individual, para cada canal de medios. Estos límites no excluyen las semanas sin inversión publicitaria.',
  cancel: 'Cancelar',
  save: 'Guardar',
  positiveValueRequired: 'Se requiere un valor positivo'
}
